import {
    FILTER_RATES_BY_CARRIER,
    FINAL_SEARCH_FORM,
    RE_SORT_RATE_CARD,
    SAVE_SEARCH_FORM_PARAM,
    SET_AIR_JSON, SET_CLIENT_JWT,
    SET_FILTER_BY_CHEAPER,
    SET_INIT_AUTH,
    SET_JWT_TOKEN,
    SET_PORT_DESTINATION_JSON,
    SET_PORT_ORIGIN_JSON,
    SET_QUERY_PARAMS,
    SET_REFERRAL_DATA,
    SET_SEA_FCL_JSON,
    SET_SEA_LCL_JSON,
    SET_SHOW_RESULT_CARD,
    SET_URL,
    SET_UUID_URL_PARAMS_DATA,
    SHOW_FORM,
    SHOW_BACK_PORTAL,
    UPDATE_ERROR,
    UPDATE_PICKUP_DELIVERY_ERS_LINE,
    UPDATE_POSTAL_ZIP_CODE,
    SET_DISCOUNT,
    SET_COMMODITY_CATEGORY_LIST,
    INSURANCE_AUTH_TOKEN,
    UPDATE_TRANSIT_TIME,
    UPDATE_PORT_TO_PORT_TRANSIT_TIME,
    SET_CARD_SCHEDULE,
    SET_SELECTED_SCHEDULE,
    BOOKING_CUSTOMER_FORM,
    SET_SELECTED_CARRIER,
    SET_SELECTED_ETD_SCHEDULE,
    SET_SELECTED_ETA_SCHEDULE,
    SET_SCHEDULE_ID,
} from './types';

import {
    API_KEY,
    AUTH_TOKEN,
    BOOK_NOW_URL,
    REMOVE_FCL_45_HC_CONTAINER,
    SAILING_SCHEDULE_POST_URL,
    SAVE_QUOTE_URL,
    SEARCH_BAR_URL,
    SEARCH_CONTACT_FORM_URL,
    SEARCH_SAILING_SCHEDULE_TIMEOUT_MIN,
    SEARCH_ZIP_CODE_POST_URL,
    SEARCH_ZIP_CODE_TIMEOUT_MIN,
    SHOW_CUSTOM_PORTS_DROPDOWN,
    USER_EMAIL_BLUR_CARDS_POST_URL,
} from '../envVariables';

import localFCLJSON from '../data/sea-fcl.json';
import localLCLJSON from '../data/sea-lcl.json';
import localAIRJSON from '../data/air.json';
import {
    add_transit_time,
    get_all_ports,
    get_all_ports_from_db,
    get_buying_rate,
    get_Client_Rate,
    get_commodity_list,
    get_factor_details_from_database
} from '../GraphQL/entities'
// sailing schedule post response json
import localSailingScheduleJSON from '../data/sailing-schedule-post-res.json';
import configureStore from '../store';

// zip code post response
import localZipCodePostJSON from '../data/zip-code-post.json';

import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import {isEmpty} from '../util/isEmpty';
import {isDevENV} from '../util/isDevENV';
import {tryParseJSON} from '../util/tryParseJSON';
import getNewRatesByUUID from '../util/getNewRatesByUUID';
import {updateOriginalRateJson} from '../util/updateOriginalRateJson';
import {getPostalUpdatedFclLclAirJson} from '../util/getPostalUpdatedFclLclAirJson';
import {getActiveShipmentMode} from '../util/getActiveShipmentMode';
import {getSailingPOSTparam} from '../util/getSailingPOSTparam';
import {
    setFormZipCodeSubmitLoading,
    setOverlayFullScreen,
    setTransparentOverlay,
    showSearchBlurCards,
    updateParentScrollbarPosition,
    updateRateCardsInfo,
} from './code_config_actions';

import {getFclOverweightContainer} from '../util/getFclOverweightContainer';
// import {
//   saveSearchOriginPortsJson,
//   saveSearchDestinationPortsJson,
// } from './cache_actions-d';
// import { isPortCacheValid } from '../util/cacheUtils-d';
import {checkFcl45hqPrice} from '../util/checkFcl45hqPrice';
import {resetSidebarRoleIncoterm, updateSidebarRoleIncoterm,} from '../util/updateSidebarRoleIncoterm';
import {shouldRedirectChild} from '../util/shouldRedirectChild';
import {cleanPickupDeliveryJson} from '../util/cleanPickupDeliveryJson';
import {saveSearchBlurCardsEmail} from './cache_actions';

import {sendSaveQuoteData, getDiscount, sendActivityData, saveLogActivityData, getAgentProfilesData, getCargoInsurance, getCargoInsurancePolicy, sendQuoteRequest } from "../GraphQL/entities"
// import {
//     LANDING_PAGE_SEARCH_CLICK_URL,
//   } from '../envVariables';

/**
 * @module route_action
 * @redux
 * @description These are redux actions creators related to Search page.
 * @category Search Page
 * @subcategory actions
 */

const LOCAL_SERVER_URL = 'http://localhost:5000/';
/**
 * @function
 * @name getQueryParams
 * @description It gets query params from url
 * @param {string} fullUrl - browser address url
 * @returns {Object} query params
 * @example
 * console.log(getQueryParams(
 * "http://ratesearch.primefreight.com/?from=%257B%2522id%2522%253A653441%252C%2522name%2522%253A%2522Chittagong%2522%252C%2522country%2522%253A%2522Bangladesh%2522%257D&to=%257B%2522id%2522%253A16%252C%2522name%2522%253A%2522Coffs%2520Harbour%2522%252C%2522country%2522%253A%2522Australia%2522%257D&date=19%20May%2C%202021&type=api-fcl"
 * ));
 *
 * //output
 * {
 * date: "19 May, 2021",
 * from: {country: "Bangladesh", id: 65441, name: "Chittagong"},
 * to: {country:"Australia", id: 65341, name: "Coffs Harbour"},
 * type: "api-fcl"
 * }
 */
const getQueryParams = (fullUrl) => {
    fullUrl =
        fullUrl && !isEmpty(fullUrl) && new URL(fullUrl).search.substring(1);
    let query_params = qs.parse(fullUrl);
    // console.log({ query_params });

    if (tryParseJSON(decodeURIComponent(query_params.from))) {
        query_params = {
            ...query_params,
            from: tryParseJSON(decodeURIComponent(query_params.from)),
        };
    }

    if (tryParseJSON(decodeURIComponent(query_params.to))) {
        query_params = {
            ...query_params,
            to: tryParseJSON(decodeURIComponent(query_params.to)),
        };
    }

    if (tryParseJSON(decodeURIComponent(query_params.discount))) {
        query_params = {
            ...query_params,
            discount: tryParseJSON(decodeURIComponent(query_params.discount)),
        };
    }

    //if url params from/to objects have city keys instead of name then map it to name
    if (!isEmpty(query_params.from)) {
        let tempFrom = query_params.from;
        query_params = {
            ...query_params,
            from: {
                id: tempFrom.id,
                name: tempFrom.name || tempFrom.city,
                country: tempFrom.country,
            },
        };
    }

    if (!isEmpty(query_params.to)) {
        let tempTo = query_params.to;
        query_params = {
            ...query_params,
            to: {
                id: tempTo.id,
                name: tempTo.name || tempTo.city,
                country: tempTo.country,
            },
        };
    }

    // console.log('getQueryParams queryParams: ', query_params);
    if(query_params.date === ''){
        const currentDate = new Date()
        query_params ={
            ...query_params,
            date: currentDate
        }
    }
    return query_params;

};

/**
 * @function
 * @name setURL
 * @description  It saves url in redux store so it can be used in browser address field
 * @param {Function} dispatch - redux dispatch
 * @param {Object} queryParams - query params
 * @returns {Redux.Action} The generated action
 */
export const setURL = async (dispatch, queryParams) => {
    let tempQueryParams = {
        ...queryParams,
        from: encodeURIComponent(JSON.stringify(queryParams.from)),
        to: encodeURIComponent(JSON.stringify(queryParams.to)),
    };

    const query = qs.stringify({
        ...tempQueryParams,
    });
    const url = `?${query}`;
    dispatch({
        type: SET_URL,
        payload: url,
    });
};


export const setJWTForRedux = async (dispatch) => {
    const LOGIN_URL = isDevENV() ? "https://primefreight-portal-dev.herokuapp.com/proxy-request?url=https://primefreight.bettywebblocks.com/public_user" : "https://primefreight.bettywebblocks.com/public_user"
    let response = await API_Call_For_JWT(LOGIN_URL)
    // Map jwt token in payload to save in state
    let payload = {
        "JWT_TOKEN": response.jwtToken,
        "Access_Expire_AT": response.accessExpiresAt,
        "Refresh_Token": response.refreshToken
    }
    // dispatching JWT

    dispatch({
        type: SET_JWT_TOKEN,
        // payload: localPORTJSON,
        payload: payload,
    });
}

// export const getFactory = (callback) => async (dispatch,getState) => {
//  let response= await get_factor_details_from_database(getState)
//   if(response.status ==="200"){
//
//   }else{
//     dispatch(updateErrorAndLoading(response.message, false));
//   }
// }

/**
 * @function
 * @name getInitAuth
 * @description  it saves user and verification in redux store
 * @param {Function} callback - callback
 * @returns {Redux.Action} The generated action
 */
export const getInitAuth = (callback) => async (dispatch, getState) => {
    let queryParams = getQueryParams(window.location.href);
    // if user and verification not present, then get it from top level
    // client said it doesn't have to get uuid/verification from parent site url
    // still I am adding it
    if (!queryParams.user && !queryParams.verification) {
        queryParams = getQueryParams(document.referrer);
    }

    const auth = {
        user: queryParams.user,
        verification: queryParams.verification
    };


    if (queryParams.showForm && queryParams.showForm.toLowerCase() === 'true') {
        dispatch({type: SHOW_FORM, payload: true});
        if(queryParams?.discount){
            const result =  await getDiscount(queryParams, getState)
            if(result[0] === 200 && result[1]){
                const data = result[1]
                dispatch({type: SET_DISCOUNT, payload: data});
            }
        }
    } else {
        dispatch({type: SHOW_FORM, payload: false});
    }

    if(queryParams.showBackBtn && queryParams.showBackBtn.toLowerCase() === 'true') {
        dispatch({type: SHOW_BACK_PORTAL, payload: true});
    } else {
        dispatch({type: SHOW_BACK_PORTAL, payload: false});
    }

    dispatch({
        type: SET_INIT_AUTH,
        // payload: JSON.stringify(auth),
        payload: auth,
    });
    if (queryParams.token !== undefined && queryParams.expire_at !== undefined) {

        let payload = {
            "JWT_TOKEN": queryParams.token,
            "Access_Expire_AT": queryParams.expire_at,
            "Refresh_Token": queryParams.token
        }

        dispatch({
            type: SET_CLIENT_JWT,
            payload: payload,
        });

        // Query to add factory and shipper details to store
        let response = await get_Client_Rate(getState, {}, false, dispatch, true)
        if (response.status !== "200") {
            dispatch(updateErrorAndLoading(response.error, false));
        }

    }

    if (callback) {
        callback();
    }
};

/**
 * @function
 * @name getReferralData
 * @description  it saves referral_code and referral_type in redux store
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
// TODO-it doesn't appear during landing page to search page transition
export const getReferralData =
    (callback = undefined) =>
        async (dispatch) => {
            let queryParams = getQueryParams(window.location.href);

            // if referral code and referral type not present, then get it from top level
            // client said it doesn't have to get uuid/verification from parent site url
            // still I am adding it
            if (!queryParams.referral_code && !queryParams.referral_type) {
                queryParams = getQueryParams(document.referrer);
            }

            // console.log(
            //   'getReferralData: react app: ',
            //   JSON.stringify(window.location.href),
            //   ', wp site:',
            //   JSON.stringify(document.referrer)
            // );

            const refferal = {
                referral_code: queryParams.referral_code,
                referral_type: queryParams.referral_type,
            };

            // console.log({ refferal });

            dispatch({
                type: SET_REFERRAL_DATA,
                payload: refferal,
            });

            if (callback) {
                callback();
            }
        };


/**
 * @function
 * @name getUuidUrlParams
 * @description  it saves req_uuid and uuid_verification in redux store
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getUuidUrlParams =
    (callback = undefined) =>
        async (dispatch) => {
            let queryParams = getQueryParams(window.location.href);

            // if "req_uuid" and "uuid_verification" not present, then get it from top level
            // client said it doesn't have to get uuid/verification from parent site url
            // still I am adding it
            if (!queryParams.req_uuid && !queryParams.uuid_verification) {
                queryParams = getQueryParams(document.referrer);

            }

            const uuid = {
                req_uuid: queryParams.req_uuid,
                uuid_verification: queryParams.uuid_verification,
            };

            // console.log({ uuid });

            dispatch({
                type: SET_UUID_URL_PARAMS_DATA,
                payload: uuid,
            });

            if (callback) {
                callback();
            }
        };


export const filter_rates_by_carrier = (company_name, checkbox) => async (dispatch, getState) => {
    let all_fcl_rates = getState().route.seaFCLJSON

    if (!checkbox) {
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            return {...object, blockRoute: false};
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                return {...object, blockRoute: false};
            });
        }
    } else if (company_name !== "") {
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            return {...object, blockRoute: false};
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                return {...object, blockRoute: false};
            });
        }
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            if (object.sealine !== company_name) {
                return {...object, blockRoute: true};
            }
            return object;
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                if (object.sealine !== company_name) {
                    return {...object, blockRoute: true};
                }
                return object;
            });
        }
    }

    dispatch({
        type: FILTER_RATES_BY_CARRIER,
        payload: all_fcl_rates
    })
}

/**
 * @function
 * @name getJSON
 * @description  it gets remote rate card json for FCL/LCL/AIR mode of transport on search page
 * @param {string | Object} [urlData={}] - either browser url or query params object
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getJSON =
    (urlData = {}, callback = null) =>
        async (dispatch, getState) => {


            if (isEmpty(getState().code_config.initAuth)) {
                // console.log("session json is empty");
                dispatch(getInitAuth(() => {
                }));
                return;
            }
            // get referral code and type
            if (isEmpty(getState().code_config.referralData)) {
                dispatch(getReferralData());
            }

            // get "req_uuid" and "uuid_verification"
            if (isEmpty(getState().code_config.uuidUrlParamsObj)) {
                dispatch(getUuidUrlParams());
            }

            let queryParams = {};

            //add total_shipment for when air/volume sliders value change
            if (
                isEmpty(urlData) &&
                getState().route.queryParams.type === 'api-air' &&
                !isEmpty(getState().route.airJSON)
            ) {
                // console.log('when air weight changes queryParams');
                queryParams = getState().route.queryParams;
                // console.log('here air queryParams: ', queryParams);
            } else {
                queryParams = !urlData.type ? getQueryParams(urlData) : urlData;

                // console.log('my queryParams: ', queryParams);

                // if queryParams is empty then return
                if (!queryParams || isEmpty(queryParams)) {
                    return;
                }

                // return search mode init reuqest if showForm = true, isFormSubmitSuccess = false
                // it is added here newly
                if (
                    queryParams.showForm &&
                    queryParams.showForm.toLowerCase() === 'true' &&
                    !getState().form.isFormSubmitSuccess
                ) {
                    console.log('return unneccessary rqeuest');
                    return;
                }

                if (queryParams && !queryParams.type) {
                    //set default search type to query params
                    queryParams = {
                        ...queryParams,
                        type: 'api-fcl',
                    };
                }

                dispatch({
                    type: SET_QUERY_PARAMS,
                    payload: queryParams,
                });

                if (
                    !queryParams.from ||
                    isEmpty(queryParams.from) ||
                    !queryParams.to ||
                    isEmpty(queryParams.to)
                ) {
                    console.log('Empty "from" or "to" field');
                    dispatch(
                        updateErrorAndLoading('Empty "from" or "to" field', undefined)
                    );
                    return;
                }

                //set url
                await setURL(dispatch, queryParams);
                // if landing page is used then invoke callback
                // dataPolling is !isLandingPageExist, so !dataPolling is isLandingPageExist
                if (!getState().code_config.dataPolling) {
                    if (callback) callback();
                    return;
                }
            }

            // dispatch(updateErrorAndLoading(undefined, true));

            let form_params;

            try {
                //Search Post request

                let axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                    },
                };

                let inputParams = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                };

                //add google recaptcha res code if showform=false and user is not present
                const {user, verification} = getState().code_config.initAuth;

                const isUserPresent = !!(user && verification);
                if (!getState().form.isFormSubmitSuccess && !isUserPresent) {
                    inputParams.gre_res = getState().code_config.reCaptchaResCode;
                }

                form_params = getSearchBookSaveParams(undefined, getState) || {};
                form_params.type = queryParams.type;

                //only for adding date
                form_params = {
                    ...form_params,
                    pickup: {...form_params.pickup, date: queryParams.date},
                };
                //add total_shipment for air weight change
                if (
                    queryParams.type === 'api-air' &&
                    !isEmpty(getState().route.airJSON)
                ) {
                    // console.log('when air weight changes:', inputParams);
                    form_params = {
                        ...form_params,
                        total_shipment: getState().code_config.airShipment,
                    };
                }

                inputParams = {
                    ...inputParams,
                    form_params,
                };

                dispatch({
                    type: SAVE_SEARCH_FORM_PARAM,
                    payload: {form_params: form_params, show: false},
                });

                // show overlay
                dispatch(setOverlayFullScreen(true));
                let response = {};

                if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
                    await setJWTForRedux(dispatch)
                }

                if(queryParams?.discount){
                    const result =  await getDiscount(queryParams, getState)
                    if(result[0] === 200 && result[1]){
                        const data = result[1]
                        dispatch({type: SET_DISCOUNT, payload: data});
                    }
                }
                // add graphql logic here

                let graphql_response_for_rates = {}
                if (getState().route.CLIENT_TOKEN.JWT_TOKEN !== undefined) {
                    console.log(" In Client PORTAL")
                    graphql_response_for_rates = await get_Client_Rate(getState, inputParams, false, dispatch)
                } else {
                    graphql_response_for_rates = await get_buying_rate(getState, inputParams, false, dispatch)
                }
                if (graphql_response_for_rates.status !== "200") {
                    dispatch(
                        updateErrorAndLoading(graphql_response_for_rates.error, undefined)
                    );
                } else {
                    // reset sidebar services
                    resetSidebarRoleIncoterm(dispatch);
                    if(graphql_response_for_rates.error===undefined) {
                        switch (queryParams.type) {
                            case 'api-fcl':
                                graphql_response_for_rates.response.rates.fcl.forEach((object, index) => {
                                    graphql_response_for_rates.response.rates.fcl[index].blockRoute = false
                                })
                                response.data = graphql_response_for_rates.response
                                response.data = checkFcl45hqPrice(response.data);
                                dispatch({type: SET_SEA_FCL_JSON, payload: response.data});
                                break;
                            case 'api-lcl':
                                graphql_response_for_rates.response.rates.lcl.forEach((object, index) => {
                                    graphql_response_for_rates.response.rates.lcl[index].blockRoute = false
                                })
                                response.data = graphql_response_for_rates.response
                                dispatch({type: SET_SEA_LCL_JSON, payload: response.data});
                                break;
                            case 'api-air':
                                response.data = graphql_response_for_rates.response
                                dispatch({type: SET_AIR_JSON, payload: response.data});
                                break;
                            default:
                                response.data = {};
                                dispatch({type: SET_SEA_FCL_JSON, payload: response.data});
                        }
                    }

                    //set search show blur cards to true
                    dispatch(showSearchBlurCards(true));

                    // reset rate cards state whether cards are expanded or not
                    dispatch(updateRateCardsInfo(null));

                    // update sidebar checkboxes based on all cards
                    updateSidebarRoleIncoterm(response.data, dispatch);

                    // set empty array to old saved zip code array
                    dispatch({type: UPDATE_POSTAL_ZIP_CODE, payload: []});

                    // for data polling
                    // dataPolling is !isLandingPageExist, so !dataPolling is isLandingPageExist
                    if (getState().code_config.dataPolling) {
                        // console.log('should do data polling: ', dataPolling);
                        // get new rate + old rate
                        // await getNewRatesByUUID(queryParams, response.data, dispatch, getState);
                        getNewRatesByUUID(queryParams, response.data, dispatch, getState);

                    }

                    //for contact form
                    let shouldSaveFormParams = false;

                    if (queryParams.type === 'api-fcl') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.fcl) &&
                                response.data.rates.fcl.length !== 0);
                    } else if (queryParams.type === 'api-lcl') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.lcl) &&
                                response.data.rates.lcl.length !== 0);
                    } else if (queryParams.type === 'api-air') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.air) &&
                                response.data.rates.air.length !== 0);
                    }
                    //save old params and show the contact form
                    // shouldSaveFormParams &&
                    dispatch({
                        type: SAVE_SEARCH_FORM_PARAM,
                        payload: {form_params, show: shouldSaveFormParams},
                    });

                    dispatch(updateErrorAndLoading(undefined, undefined));
                    dispatch({
                        type: SET_SHOW_RESULT_CARD,
                        payload: isEmpty(response.data),
                    });

                    //sort or re-sort rates cards upon clicking search btn
                    dispatch({type: RE_SORT_RATE_CARD});

                    // cb
                    if (callback) callback();
                }


            } catch (err) {
                console.log(err);
                dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));

                // only show if there is server response
                let seaFCLJSON = getState().route.seaFCLJSON;
                let seaLCLJSON = getState().route.seaLCLJSON;
                let airJSON = getState().route.airJSON;
                if (isEmpty(seaFCLJSON) && isEmpty(seaLCLJSON) && isEmpty(airJSON)) {
                    dispatch({type: SET_SHOW_RESULT_CARD, payload: true});
                }

                //make search form params , show contact form
                dispatch({
                    type: SAVE_SEARCH_FORM_PARAM,
                    payload: {form_params, show: true},
                });

                if (callback) {
                    callback();
                }
            }

            // hide overlay
            dispatch(setOverlayFullScreen(false));
        };

/**
 * @function
 * @name submitSearchContactForm
 * @description It submits Contact form data on top of all results cards on Search page
 * @param {Object} [contactFormData={}] - contact form data e.g. `{name: "name", email:"email@xyz.com"}`
 * @param {Function} [callback=null] - callback
 * @returns {Redux.Action} The generated action
 */
export const submitSearchContactForm =
    (contactFormData = {}, callback = null) =>
        async (dispatch, getState) => {
            try {
                let axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                    },
                };

                let inputParams = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    form_params: getState().route.savedFormParams,
                    contact_data: contactFormData,
                };

                //console.log('submitSearchContactForm inputParams', inputParams);
                // return;

                dispatch(updateErrorAndLoading(undefined, true));

                const response = await sendQuoteRequest(contactFormData, getState)

                if (response.status) {
                    response.data = {
                        message: 'Form has been successfully submitted!',
                    };
                } else{
                    dispatch(updateErrorAndLoading("Form has not been successfully submitted! Try Again.", undefined));
                }

                dispatch(updateErrorAndLoading(undefined, undefined));
                if (callback) {
                    callback(response.data && response.data.message);
                }
            } catch (err) {
                console.log(err);
                dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
                if (callback) callback(null);
            }
        };

/**
 * @function
 * @name closeSearchContactForm
 * @description  it closes the contact form on search page
 * @returns {Redux.Action} The generated action
 */
export const closeSearchContactForm = () => (dispatch) => {
    //save search form params, {} for success POST request
    // console.log('closeSearchContactForm');

    dispatch({
        type: SAVE_SEARCH_FORM_PARAM,
        payload: {
            form_params: {},
            show: false,
        },
    });
};

/**
 * @function
 * @name setQueryParams
 * @description  it saves query params in redux store
 * @param {Object} queryParams - query params
 * @returns {Redux.Action} The generated action
 */
export const setQueryParams = (queryParams) => async (dispatch) => {
    dispatch({type: SET_QUERY_PARAMS, payload: queryParams});
};

/**
 * @function
 * @name updateErrorAndLoading
 * @description  it updates error message and spinner loading state
 * @param {string} [error=''] - error message to be shown via in-app notify at bottom-right corner
 * @param {boolean} [loading=false] - whether to show loading spinner
 * @returns {Redux.Action} The generated action
 */
export const updateErrorAndLoading =
    (error = '', loading = false) =>
        async (dispatch) => {
            dispatch({type: UPDATE_ERROR, payload: {error, loading}});
        };

/**
 * @function
 * @name getSearchBookSaveParams
 * @description  it adds pickup and delivery data to an empty object argument
 * @param {Object} [data={}] - empty object
 * @param {Redux.State} getState - whole redux state
 * @returns {Object} it contains pickup and delivery data
 */
const getSearchBookSaveParams = (data = {}, getState) => {
    //add pickup, delivery
    data = {
        ...data,
        pickup: {
            date: getState().route.queryParams.date,
            selectedPort: getState().route.queryParams.from,
        },
        delivery: {
            selectedPort: getState().route.queryParams.to,
        },
    };
    return data;
};

// get selectedPort when isFormSubmitSuccess is true
const getFormSelectedPort = (type, getState) => {
    const pickupDeliveryType = getState().form[type][`${type}Type`];
    const isExistingFactorySelected =
        getState().form.factoryInfo[type].isExistingFactorySelected;

    let selectedPort = {};

    if (pickupDeliveryType === 'port') {
        let pickupDeliveryJson = getState().form[type];
        selectedPort = {
            id: pickupDeliveryJson.id,
            country: pickupDeliveryJson.country,
            city: pickupDeliveryJson.city,
        };
    }

    if (pickupDeliveryType === 'factory' && isExistingFactorySelected) {
        let selectedFactoryJson = getState().form[type].selectedExistingFactoryJson;

        if (selectedFactoryJson && !isEmpty(selectedFactoryJson)) {
            if (selectedFactoryJson.port && !isEmpty(selectedFactoryJson.port)) {
                selectedPort = selectedFactoryJson.port;
            }
        }
    }

    // for adding selectedPort to pickup/delivery for new factory type
    if (pickupDeliveryType === 'factory' && !isExistingFactorySelected) {
        selectedPort = getState().form.factoryInfo[type].newFactory.port || {};
    }

    // // for delivery ecommerce and amazon mode, add selected port
    // if (
    //   type === 'delivery' &&
    //   (pickupDeliveryType === 'ecommerce' || pickupDeliveryType === 'amazon')
    // ) {
    //   const ecommAmazonModeKey =
    //     pickupDeliveryType === 'ecommerce' ? 'ecommerceMode' : 'amazonMode';

    //   const selectedFactory = getState().form[type][ecommAmazonModeKey] || {};

    //   const ecommAmazonSelectedJsonKey =
    //     pickupDeliveryType === 'ecommerce'
    //       ? 'selectedEcommerceJson'
    //       : 'selectedAmazonJson';

    //   const selectedFactoryJson =
    //     selectedFactory[ecommAmazonSelectedJsonKey] || {};

    //   if (selectedFactoryJson && !isEmpty(selectedFactoryJson)) {
    //     if (selectedFactoryJson.port && !isEmpty(selectedFactoryJson.port)) {
    //       selectedPort = {
    //         id: selectedFactoryJson.port.id,
    //         country: selectedFactoryJson.port.country,
    //         city: selectedFactoryJson.port.city,
    //       };
    //     }
    //   }
    // }

    // sanitize selected port
    selectedPort = {
        id: selectedPort.id,
        country: selectedPort.country,
        city: selectedPort.city || selectedPort.name,
    };

    return {selectedPort};
};

export const saveBookingFormInfo = (data) => async (dispatch, getState) =>{
    dispatch({
        type: BOOKING_CUSTOMER_FORM,
        payload: data
    })
}

export const getAllAgentProfiles = (isUserPresent) => async (dispatch, getState) => {
    try{
        const response = await getAgentProfilesData(isUserPresent, getState);
        return response
    }catch(error){
        console.error("Error in getting Agent Profiles : ",error)
    }

};

export const getInsuranceQuoteFromAPI = (isUserPresent,insuranceToken, payload, customer ) => async (dispatch,getState) =>{
    // console.log("payload: ",payload)
    try{
        const response = await getCargoInsurance(isUserPresent,insuranceToken, payload, customer, getState);
        // console.log("response", response);
        return response
    }catch(error){
        console.error(error)
    }
}

export const getInsurancePolicyFromAPI = (isUserPresent,insuranceToken, quoteId) => async (dispatch,getState) =>{
    try{
        const response = await getCargoInsurancePolicy(isUserPresent,insuranceToken, quoteId, getState);
        return response
    }catch(error){
        console.error(error)
    }
}

export const save_final_form = (final_form, isSaveQuoteClicked) => async (dispatch, getState) => {
    dispatch({
        type: FINAL_SEARCH_FORM,
        payload: final_form
    })
    if(isSaveQuoteClicked){
    let jwtToken = getState()?.route?.CLIENT_TOKEN?.JWT_TOKEN
    // console.log("GetState--: ",getState(),"final form: ",final_form);
    const delivery_selected_index = final_form?.selected_card_detail?.delivery_selected_option_index
    const pickup_selected_index = final_form?.selected_card_detail?.pickup_selected_option_index
    let saveQuoteObject={
        carrier: final_form?.selected_card_json?.carrier.id,
        charge_id:final_form?.selected_card_json?.charge_id,
        charge_type_id:final_form?.selected_card_json?.charge_type_id,
        origin_port: getState()?.route?.queryParams?.from?.id,
        destination_port: getState()?.route?.queryParams?.to?.id,
        book_price: final_form?.selected_card_json?.bookNowPrice,
        ETD_origin:final_form?.selected_card_json?.etd_origin,
        discharge_port: final_form?.selected_card_json?.port_of_discharge?.id,
        vessel_service: final_form?.selected_card_json?.vessel_Service?.id,
        validity_from: final_form?.selected_card_json?.valid_date_from,
        validity_to: final_form?.selected_card_json?.valid_date_to,
        isDischargeChecked: final_form?.selected_card_detail?.discharge_isChecked,
        isErsChecked: final_form?.selected_card_detail?.ers_isChecked,
        isFreightChecked: final_form?.selected_card_detail?.frieght_isChecked,
        isPortOriginChecked: final_form?.selected_card_detail?.origin_isChecked,
        isPickupChecked: final_form?.selected_card_detail?.pickup_isChecked,
        isDeliveryChecked: final_form?.selected_card_detail?.delivery_isChecked,
        vendor_contract: final_form?.selected_card_json?.vendor_contract?.id,
        mode_of_transport: final_form?.selected_card_json?.mode
    };

    if(final_form.type === "api-lcl"){
        saveQuoteObject= {
            ...saveQuoteObject,
            chargeable_weight: final_form?.chargeableWeight,
            container_type:"LCL",
            freight_rate: Number(final_form?.freightRate)
        }
    }else if(final_form.type === "api-fcl"){
        saveQuoteObject= {
            ...saveQuoteObject,
            _20stCounter:final_form?.container?._20stCounter,
            _40hqCounter:final_form?.container?._40hqCounter,
            _40stCounter:final_form?.container?._40stCounter,
            _45hqCounter:final_form?.container?._45hqCounter,
            _20stPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._20stPrice) : Number(final_form?.selected_card_json?.["20st"]),
            _40hqPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._40hqPrice) : Number(final_form?.selected_card_json?.["40hq"]),
            _40stPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._40stPrice) : Number(final_form?.selected_card_json?.["40st"]),
            _45hqPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._45hqPrice) : Number(final_form?.selected_card_json?.["45hq"]),
            container_type:"FCL"
        }
    }

    const pickupSection = final_form?.selected_card_json?.pickup_section?.[pickup_selected_index] || {}
    const deliverySection= final_form?.selected_card_json?.delivery_section?.[delivery_selected_index] || {}

    let deliveryRateArr =[];
    if(deliverySection && deliverySection.hasOwnProperty("rate") && Array.isArray(deliverySection.rate)){
        deliveryRateArr = final_form?.selected_card_detail?.delivery_charges
    }

    let pickupRateArr =[];
    if(pickupSection && pickupSection.hasOwnProperty("rate") && Array.isArray(pickupSection.rate)){
        pickupRateArr = final_form?.selected_card_detail?.pickup_charges
    }
    const dischargeObject = {
        ers_section: final_form?.selected_card_detail?.ers_charges,
        port_origin_section: final_form?.selected_card_detail?.port_fees_from_charges,
        port_discharge_section: final_form?.selected_card_detail?.port_fees_to_charges,
        pickup_section_charges:pickupRateArr,
        pickup_section : pickupSection,
        delivery_section: deliverySection,
        delivery_section_charges: deliveryRateArr,
        discountID : getState()?.route?.discount?.id,
    }
    try {
        const res = await sendSaveQuoteData(jwtToken,saveQuoteObject,dischargeObject);
        if(res){
            dispatch(updateErrorAndLoading('Quote has been saved', undefined));
        } else{
            dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
        }
    } catch (error) {
        console.error("Error:", error);
    }
}
}

/**
 * @function
 * @name postBookSaveChatUserData
 * @description  it is invoked when booknowprice/chat/savequote button is clicked on a rate card on search page
 * @param {Object} data - selected rate card data
 * @param {boolean} isSaveQuoteClicked - whether save quote button is clicked
 * i.e. `true` - save quote button is clicked, `false` - Book now button is clicked
 * @param {boolean} isChatClicked - whether chat button is clicked
 * (chat button is no longer in use, it was removed, so it's always `false`)
 * @returns {Redux.Action} The generated action
 */
export const postBookSaveChatUserData =
    (data, isSaveQuoteClicked, isChatClicked) => async (dispatch, getState) => {
        try {
            if (getState().form.isFormSubmitSuccess) {
                data.form_params = {};
                if (getState().code_config.showFormCustomService) {
                    data.form_params.customService = getState().form.customService;
                }

                data.form_params.pickup = cleanPickupDeliveryJson(
                    getState,
                    'pickup'
                ).newDataJson;

                data.form_params.delivery = cleanPickupDeliveryJson(
                    getState,
                    'delivery'
                ).newDataJson;

                data.form_params.type = data.type;
                data.form_params.factoryInfo = getState().form.factoryInfo;

                // add total number of overweight containers for FCL
                if (getState().form.isFclTabActive) {
                    data.form_params.overweightContainer =
                        getFclOverweightContainer(getState);
                }
            } else {
                data.form_params = getSearchBookSaveParams({}, getState);
                data.form_params.type = data.type;
                dispatch({
                    type: FINAL_SEARCH_FORM,
                    payload: data
                })
            }

            if (data.type !== 'api-fcl') {
                data.form_params.total_shipment = data.total_shipment;
            } else {
                // TODO- fix isOverweight null in case in Form mode
                const tempContainer = data.container;
                let tempContainerArr = [];
                if (tempContainer._20stCounter) {
                    tempContainerArr.push({
                        input: tempContainer._20stCounter,
                        type: "20'",
                        isOverweight: null,
                    });
                }
                if (tempContainer._40stCounter) {
                    tempContainerArr.push({
                        input: tempContainer._40stCounter,
                        type: "40'",
                        isOverweight: null,
                    });
                }
                if (tempContainer._40hqCounter) {
                    tempContainerArr.push({
                        input: tempContainer._40hqCounter,
                        type: "40'HC",
                        isOverweight: null,
                    });
                }
                if (!REMOVE_FCL_45_HC_CONTAINER && tempContainer._45hqCounter) {
                    tempContainerArr.push({
                        input: tempContainer._45hqCounter,
                        type: "45'HC",
                        isOverweight: null,
                    });
                }
                data.form_params.fclShipping = tempContainerArr;
            }

            if (isSaveQuoteClicked) {
                data.object_type = 'quote_save'; //for quoteSave byn
            } else if (!isSaveQuoteClicked && !isChatClicked) {
                data.object_type = 'shipment_booking'; //for bookNow btn
            }

            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                },
            };
            const tempData = {
                form_params: {...data.form_params, origin: data.origin},
                container: data.container,
                selected_card_json: data.selected_card_json,
                selected_card_detail: data.selected_card_detail,
                zipCodes: data.zipCodes,
                queryParams:getState().route.queryParams,
                jwtToken:getState().route.JWT_TOKEN,
                object_type: data.object_type,
            };
            const params = {
                ...tempData,
                apiKey: API_KEY,
                Authorization: `Bearer ${AUTH_TOKEN}`,
                user: getState().code_config.initAuth.user,
                verification: getState().code_config.initAuth.verification,
                referral_code: getState().code_config.referralData.referral_code,
                referral_type: getState().code_config.referralData.referral_type,
                userEmailBlurCards: getState().cache.userEmailBlurCards,
                agentInfo: getState().form.AgentInformation,
                discount: getState().route.discount
            };

            //console.log('params : ', params);
            //const url = isSaveQuoteClicked ? SAVE_QUOTE_URL : BOOK_NOW_URL;

            // const bookingDataParam = encodeURIComponent(JSON.stringify(params));
            // for booknow only
            // if (!isSaveQuoteClicked) {
            //     // show overlay
            //     dispatch(setOverlayFullScreen(true));
            //     // const href = LANDING_PAGE_SEARCH_CLICK_URL + `landing-page/booking-form?bookingData=${bookingDataParam}`;
            //     // //alert(href);
            //     // Object.assign(document.createElement('a'), {
            //     //   target: '_top', //_self, _blank,   
            //     //   href,
            //     // }).click();
            // } else {
            //     // show only when book now btn is not clicked, other btn are clicked
            //     dispatch(updateErrorAndLoading(undefined, true));
            // }

            // if (isDevENV()) {
            //     await new Promise((resolve) => setTimeout(() => resolve(), 500));
            // }

            // const response = await axios.post(url, {params}, axiosConfig);
            // console.log("response : ", JSON.parse(response.data.data));

            // if (isSaveQuoteClicked) {
            //     // response.data.message = "Your quote has been saved!";
            //     dispatch(
            //         updateErrorAndLoading(
            //             JSON.stringify(response.data.message),
            //             undefined
            //         )
            //     );
            // } else {
            //     if (isDevENV()) {
            //         response.data.redirect_url = 'https://google.com'; //comment this line
            //     }

            //     if (response.data.redirect_url) {
            //         const href = response.data.redirect_url;
            //         const aTag = Object.assign(document.createElement('a'), {
            //             target: shouldRedirectChild() ? '_self' : '_top', //_self, _blank, _top
            //             href,
            //         });
            //         if (!isDevENV()) {
            //             aTag.click();
            //         }
            //     }
            //     dispatch(updateErrorAndLoading(undefined, undefined)); //stop spinning the spin

                //{ "message" :" your quote has been booked. success message",
                //"redirect_url":"https://....."}
            //}
        } catch (err) {
            console.log(err);
            dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
        }
        // hide overlay
        dispatch(setOverlayFullScreen(false));
    };

/**
 * @function
 * @name updateShipmentJSON
 * @description  it adds book now price to a rate card json
 * @param {string} id - `id` of a rate card in which book now price will be added in
 * @param {string} bookNowPrice - book now price e.g. `$ 2900.37`
 * @returns {Redux.Action} The generated action
 */
//Route add BOOKNOWPRICE to json
// remove the duplicate json card id
export const updateShipmentJSON =
    (id, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked) => async (dispatch, getState) => {
        let seaFCLJSON = getState().route.seaFCLJSON;
        let seaLCLJSON = getState().route.seaLCLJSON;
        let airJSON = getState().route.airJSON;

        //remove dollar $ sign
        bookNowPrice = parseInt(bookNowPrice.replace('$', '').trim() || 0);
// console.log('updateShipmentJSON bookNowPrice*********** ', bookNowPrice,discount,"getState().route: ",getState().route);
        // console.log('updateShipmentJSON bookNowPrice*********** ', bookNowPrice);
        // update original saved rate json, add bookNowPrice to it
        updateOriginalRateJson(id, bookNowPrice, pickup_checked, ers_checked,origin_checked, delivery_checked, discharge_checked, getState, dispatch);
        //console.log("...seaFCLJSON: ",seaFCLJSON)
        if (!isEmpty(seaFCLJSON)) {
            const fclArr = seaFCLJSON.rates.fcl.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            //console.log("...fclArray: ",fclArr)
            seaFCLJSON = {
                ...seaFCLJSON,
                rates: {...seaFCLJSON.rates, fcl: [...fclArr]},
            };
            dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});
        }

        if (!isEmpty(seaLCLJSON)) {
            const lclArr = seaLCLJSON.rates.lcl.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            seaLCLJSON = {
                ...seaLCLJSON,
                rates: {...seaLCLJSON.rates, lcl: [...lclArr]},
            };
            dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
        }

        if (!isEmpty(airJSON)) {
            const airArr = airJSON.rates.air.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            airJSON = {
                ...airJSON,
                rates: {...airJSON.rates, air: [...airArr]},
            };
            dispatch({type: SET_AIR_JSON, payload: airJSON});
        }
    };

/**
 * @function
 * @name sortCards
 * @description  it sorts rate cards
 * @returns {Redux.Action} The generated action
 */
export const sortCards = () => async (dispatch, getState) => {
    if (getState().route.filterByCheaper) {
        // console.log('im here sortCards: cheaper');
        dispatch(sortByCheaper());
    } else {
        // console.log('im here sortCards: faster');
        dispatch(sortByFaster());
    }
};

/**
 * @function
 * @name logActivity
 * @description  it sorts rate card by cheaper
 * @returns {Redux.Action} The generated action
 */
export const logActivity = () => async (dispatch, getState) => {
    const jwt_token = getState().route.JWT_TOKEN.JWT_TOKEN
    const queryParams = getState().route.queryParams
    const webuserDetails = getState().route.USER_DETAILS?.webuser
    //const formattedDate =  (new Date(queryParams.date)).toISOString().split('T')[0]; 

    let userActivityData = {
        from : queryParams.from.id,
        to : queryParams.to.id,
        user : webuserDetails?.userid,
        //activityDate : formattedDate,
        discount : getState()?.route?.discount?.id
      }
      if(queryParams.type === 'api-fcl' || queryParams.type === 'api-lcl'){
        userActivityData.mode = "Sea"
      }else if(this.props.queryParams.type === 'api-air'){
        userActivityData.mode = "Air"
      }
      
      try {
        //const res = await sendActivityData(jwt_token, userActivityData);
        const res = await saveLogActivityData(getState, userActivityData)
        if (!res) {
          console.log("Error in Logging user activity");
        }
      } catch (error) {
        console.error("Error logging user activity:", error);
      }
    
}

export const updateTransitTime = (id, transitTime, type) => ({
    type: UPDATE_TRANSIT_TIME,
    payload: { id, transitTime, type },
});

export const updatePortToPortTransitTime = (id, portTransitTime, type) => ({
    type: UPDATE_PORT_TO_PORT_TRANSIT_TIME,
    payload: { id, portTransitTime, type },
});

export const setSchedule = (id, schedule, type) => ({
    type: SET_CARD_SCHEDULE,
    payload: { id, schedule, type },
});

export const setSelectedSchedule = (id, schedule, type) => ({
    type: SET_SELECTED_SCHEDULE,
    payload: { id, schedule, type },
});

export const setScheduleId = (id, schedule, local_schedule_key, type ) => ({
    type: SET_SCHEDULE_ID,
    payload: { id, schedule, local_schedule_key, type },
});


export const update_schedule_ids_in_final_form = (id, local_schedule_key, updatedSchedule) => async (dispatch, getState) => {
const currentFinalForm = getState().route?.final_search_form;

if (!currentFinalForm || !currentFinalForm.selected_card_detail) {
    // console.log("⚠️ Cannot update schedule: FINAL_SEARCH_FORM or selected_card_detail is missing.");
    return; // Exit early if state is incomplete
}

const selectedCard = currentFinalForm.selected_card_detail;

// console.log("✅ Attempting to update schedule ID in final form with:",
//     "\nrateId:", id,
//     "\nlocal_schedule_key:", local_schedule_key,
//     "\nselectedCard:", selectedCard
// );

// Only update if IDs match
if (selectedCard.id === id && selectedCard.local_schedule_key === local_schedule_key) {
    const updatedFinalForm = {
    ...currentFinalForm,
    selected_card_detail: {
        ...selectedCard,
        selectedSchedule: updatedSchedule
    }
    };

    dispatch({
    type: FINAL_SEARCH_FORM,
    payload: updatedFinalForm
    });
} else {
    //console.log("🟡 Schedule update skipped: No matching rate or schedule key found.");
}
};
  
/**
 * @function
 * @name setSelectedCarrier
 * @description It sets the selected carrier in [Sidebar]{@Link FCLContainerType}.
 * @param {string} carrier - contains the selected carrier i.g. `{MAERSK}`
 * @returns {Redux.Action} The generated action
 */
export const setSelectedCarrier = (carrier) => ({
    type:  SET_SELECTED_CARRIER,
    payload: carrier
});

/**
 * @function
 * @name setSelectedEtdRangeSchedule
 * @description It sets the selected etd range in [Sidebar].
 * @param {string} etdRange - contains the selected etd range
 * @returns {Redux.Action} The generated action
 */
export const setSelectedEtdRangeSchedule = (etdRange) => ({
    type:  SET_SELECTED_ETD_SCHEDULE,
    payload: etdRange
});

/**
 * @function
 * @name setSelectedEtaRangeSchedule
 * @description It sets the selected eta range in [Sidebar].
 * @param {string} etaRange - contains the selected eta range
 * @returns {Redux.Action} The generated action
 */
export const setSelectedEtaRangeSchedule = (etaRange) => ({
    type:  SET_SELECTED_ETA_SCHEDULE,
    payload: etaRange
});

/**
 * @function
 * @name resetCarrierAndScheduleDateRange
 * @description It resets the selected carrier and schedule etd/eta range [Sidebar].
 * @returns {Redux.Action} The generated action
 */
export const resetCarrierAndScheduleDateRange = () => (dispatch, getState) => {
//   console.log("resetCarrierAndScheduleDateRange ");
  dispatch({ type: SET_SELECTED_CARRIER, payload: "" });
  dispatch({ type: SET_SELECTED_ETD_SCHEDULE, payload: null });
  dispatch({ type: SET_SELECTED_ETA_SCHEDULE, payload: null });
 };

/**
 * @function
 * @name sortByCheaper
 * @description  it sorts rate card by cheaper
 * @returns {Redux.Action} The generated action
 */
export const sortByCheaper = () => async (dispatch, getState) => {
    let seaFCLJSON = getState().route.seaFCLJSON;
    let seaLCLJSON = getState().route.seaLCLJSON;
    let airJSON = getState().route.airJSON;

    // console.log('sortByCheaper ******');

    if (!isEmpty(seaFCLJSON) && seaFCLJSON.rates && !isEmpty(seaFCLJSON.rates)) {
        const fclArr = _.sortBy(
            seaFCLJSON.rates.fcl,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        seaFCLJSON = {
            ...seaFCLJSON,
            rates: {...seaFCLJSON.rates, sort: 'Cheaper', fcl: [...fclArr]},
        };

        dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});
        // fclArr.map((item) =>
        //   console.log('sortByCheaper price: ', item.bookNowPrice, ' id: ', item.id)
        // );
    }

    if (!isEmpty(seaLCLJSON) && seaLCLJSON.rates && !isEmpty(seaLCLJSON.rates)) {
        const lclArr = _.sortBy(
            seaLCLJSON.rates.lcl,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        seaLCLJSON = {
            ...seaLCLJSON,
            rates: {...seaLCLJSON.rates, sort: 'Cheaper', lcl: [...lclArr]},
        };

        dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
    }

    if (!isEmpty(airJSON) && airJSON.rates && !isEmpty(airJSON.rates)) {
        const airArr = _.sortBy(
            airJSON.rates.air,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        airJSON = {
            ...airJSON,
            rates: {...airJSON.rates, sort: 'Cheaper', air: [...airArr]},
        };

        dispatch({type: SET_AIR_JSON, payload: airJSON});
    }

    dispatch({type: SET_FILTER_BY_CHEAPER, payload: true});
};

/**
 * @function
 * @name sortByFaster
 * @description  it sorts rate card by faster
 * @returns {Redux.Action} The generated action
 */
export const sortByFaster = () => async (dispatch, getState) => {
    let seaFCLJSON = getState().route.seaFCLJSON;
    let seaLCLJSON = getState().route.seaLCLJSON;
    let airJSON = getState().route.airJSON;

    // console.log('sortByFaster ******');

    if (!isEmpty(seaFCLJSON) && seaFCLJSON.rates && !isEmpty(seaFCLJSON.rates)) {
        const fclArr = _.sortBy(seaFCLJSON.rates.fcl,
            //(item) => Number(item.schedules?.transit_time),); 
            (item) => (item.schedules?.port_to_port_transit_time),); 

        seaFCLJSON = {
            ...seaFCLJSON,
            rates: {...seaFCLJSON.rates, sort: 'Faster', fcl: [...fclArr]},
        };
        // console.log(".....seaFCLJSON.....",seaFCLJSON)
        dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});

        // fclArr.map((item) =>
        //   console.log('sortByFaster price: ', item.bookNowPrice, ' id: ', item.id)
        // );
    }

    if (!isEmpty(seaLCLJSON) && seaLCLJSON.rates && !isEmpty(seaLCLJSON.rates)) {
        const lclArr = _.sortBy(seaLCLJSON.rates.lcl, [
            'transit_time',
            'bookNowPrice',
        ]);
        seaLCLJSON = {
            ...seaLCLJSON,
            rates: {...seaLCLJSON.rates, sort: 'Faster', lcl: [...lclArr]},
        };

        dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
    }

    if (!isEmpty(airJSON) && airJSON.rates && !isEmpty(airJSON.rates)) {
        const airArr = _.sortBy(airJSON.rates.air, [
            'transit_time',
            'bookNowPrice',
        ]);
        airJSON = {
            ...airJSON,
            rates: {...airJSON.rates, sort: 'Faster', air: [...airArr]},
        };

        dispatch({type: SET_AIR_JSON, payload: airJSON});
    }

    dispatch({type: SET_FILTER_BY_CHEAPER, payload: false});
};

const filterByEta = (etaRange, rates) => {
    let filteredArr =[]
    const startDateEta = etaRange?.startOf('week')?.format('DD-MMMM-YYYY');
    const endDateEta = etaRange?.endOf('week')?.format('DD-MMMM-YYYY');
    //console.log("filterRatesByEta.....startDate--", startDateEta,"endDate: ",startDateEta, "etaRange: ",etaRange)

    const startOfWeekEta = startDateEta ? new Date(startDateEta).toISOString().split('T')[0] : null;
    const endOfWeekEta = endDateEta ? new Date(endDateEta).toISOString().split('T')[0] : null;

    if (startOfWeekEta && endOfWeekEta) {
        filteredArr = rates.filter((item) => {
            const etaDestination = item?.schedules?.etaPortOfDestination || item?.schedules?.eta_destination 
            const eta = new Date(etaDestination).toISOString().split('T')[0];
            // console.log("----schedule eta----- ",eta, "eta>givenDate",eta >= startOfWeekEta && eta<=endOfWeekEta)
            //return eta > filterDate;  // Check if etd is after the filter date
            return eta >= startOfWeekEta && eta<=endOfWeekEta;
        });
    }
    return filteredArr
}

const filterByEtd = (etdRange, rates) =>{
    let filteredArr =[]
    const startDateEtd = etdRange?.startOf('week')?.format('DD-MMMM-YYYY');
    const endDateEtd = etdRange?.endOf('week')?.format('DD-MMMM-YYYY');
    //console.log("filterRatesByEta.....startDate--", startDateEtd,"endDate: ",endDateEtd, "etdRange: ",etdRange)
    const startOfWeekEtd = startDateEtd ? new Date(startDateEtd).toISOString().split('T')[0] : null;
    const endOfWeekEtd = endDateEtd ? new Date(endDateEtd).toISOString().split('T')[0] : null;
    if (startOfWeekEtd && endOfWeekEtd) {
        filteredArr = rates.filter((item) => {
            const etd = item.schedules && (item?.schedules?.etd) ? new Date(item.schedules.etd).toISOString().split('T')[0] : null;
            // console.log("----schedule etd----- ",etd, 
            //     "etd >= startOfWeek && etd<=endOfWeek",etd >= startOfWeekEtd && etd<=endOfWeekEtd)
            if (etd) {
                return etd >= startOfWeekEtd && etd <= endOfWeekEtd;
            }
            return false; // If etd is not defined, do not include this item
        });
    }
    return filteredArr
}


export const filterRatesByEtaEtd = (etaRange, etdRange, selected_carrier) => async (dispatch, getState) => {
    //console.log("---filterRatesByEtaEtd is executing.....",etaRange, etdRange)
    let seaFCLJSON = getState().route.seaFCLJSON;  // Access the current seaFCLJSON state
    let fclRates = seaFCLJSON?.rates?.fcl
    let rates = fclRates;

    let filteredJsonArr = []
    if(etaRange && etdRange){
        // console.log("---both etd and eta range are present")
        const filterdEtdRates = filterByEtd(etdRange, rates);
        // console.log("filtered rates by ETD: ",filterdEtdRates);
        const filteredEtaRates = filterByEta(etaRange, filterdEtdRates);
        // console.log("filtered rates by ETA...",filteredEtaRates)
        filteredJsonArr = filteredEtaRates

    }else if(etaRange && !etdRange){
        // console.log("---only etaRange is present----")
        const filterdEtaRates = filterByEta(etaRange, rates);
        // console.log("filterdEtaRates: ",filterdEtaRates)
        filteredJsonArr = filterdEtaRates
    }else if(!etaRange && etdRange){
        // console.log("---only etdRange is present-----")
        const filterdEtdRates = filterByEtd(etdRange, rates);
        // console.log("filterdEtdRates: ",filterdEtdRates)
        filteredJsonArr = filterdEtdRates
    }else if(!etaRange && !etdRange && selected_carrier !== ""){
        // console.log("---both etd and eta range are not present or null")
        filteredJsonArr = rates
    }else if(!etaRange && !etdRange && selected_carrier === ""){
        filteredJsonArr = rates
    }

    // If you want to update the state with filtered results
    seaFCLJSON = {
        ...seaFCLJSON,
        rates: {
            ...seaFCLJSON.rates,
            filteredJson: [...filteredJsonArr],  // Add the filtered fcl array to the rates object
        },
    };

    // Dispatch the updated seaFCLJSON to the store
    dispatch({
        type: 'SET_SEA_FCL_JSON',  // Action type
        payload: seaFCLJSON,       // Payload is the updated seaFCLJSON with filtered rates
    });
    return filteredJsonArr;
};
/**
 * @function
 * @name API_Call_For_JWT
 * @description  it gets public JWT token from bettyblocks
 * @returns {Redux.Action} The generated action JWT
 */
const API_Call_For_JWT = async (LOGIN_URL) => {
    // for production environment
    if (!isDevENV()) {
        return await axios.post(LOGIN_URL).then(res => {
            return res.data
        }).catch(err => {
            console.error(err)
        })
    } else {
        return await axios.post(LOGIN_URL).then(res => {
            return res.data.data
        }).catch(err => {
            console.error(err)
        })
    }


}

export const getJWTForAgent = () => async (dispatch, getState) => {
    //  Getting JWT token from betty blocks for graphql
    if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
        //console.log("JWT_TOKEN is undefined...",getState().route.JWT_TOKEN.JWT_TOKEN)
        await setJWTForRedux(dispatch)
    }
}
/**
 * @function
 * @name getRemotePortsJson
 * @description  it gets origin and destination ports json from remote server for custom ports dropdown
 * @returns {Redux.Action} The generated action
 */
export const getRemotePortsJson = () => async (dispatch, getState) => {
    let queryParams = getQueryParams(window.location.href);


    try {
        // let axiosConfig = {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: `Bearer ${AUTH_TOKEN}`,
        //     jsessionid: getState().code_config.initAuth,
        //   },
        // };
        // const inputParams = {
        //   apiKey: API_KEY,
        //   Authorization: `Bearer ${AUTH_TOKEN}`,
        //   user: getState().code_config.initAuth.user,
        //   verification: getState().code_config.initAuth.verification,
        // };

        // when iframe==yes and show form==yes and token is present
        // if(queryParams.iframe!==undefined && queryParams.iframe!==false && queryParams.token!==undefined){
        //  return ;
        // }

        dispatch(updateErrorAndLoading(undefined, true));

        //  Getting JWT token from betty blocks for graphql
        if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
            await setJWTForRedux(dispatch)
        }


        // to map Origin Port from betty blocks through Graphql
        if (getState().originPortJSON === undefined && getState().destinationPortJSON === undefined) {
            let graph_ql_response = await get_all_ports_from_db(getState);

            if (graph_ql_response.status !== "200") {
                dispatch(
                    updateErrorAndLoading(graph_ql_response.error, undefined)
                );
            } else {
                dispatch({
                    type: SET_PORT_ORIGIN_JSON,
                    payload: graph_ql_response.response.port_origin,
                });

                dispatch({
                    type: SET_PORT_DESTINATION_JSON,
                    payload: graph_ql_response.response.port_destination,
                });
            }

            await get_commodity_list(getState,dispatch);
            
        }

    } catch (err) {
        console.log(err);
        dispatch(
            updateErrorAndLoading(
                JSON.stringify(err.message) + ', error in getting Ports',
                undefined
            )
        );
    }
};

/**
 * @function
 * @name postZipCodeData
 * @description  It's for posting zip code when user enters postal code and click on Submit on a rate card on search page.
 * In form mode it is auto submitted after form is submitted successfully
 * @param {Object} postalObj - postal data
 * @param {Function} [callback=undefined] - callback
 * @param {boolean} formZipCodeSubmit - `true` - used for Form page, `false` - used for search page
 * @returns {Redux.Action} The generated action
 */

// formZipCodeSubmit boolean is for zip code submit from search mode or form mode
export const postZipCodeData =
    (postalObj, callback = undefined, formZipCodeSubmit = undefined) =>
        async (dispatch, getState) => {
            let response = {};
            try {
                let axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                        user: getState().code_config.initAuth.user,
                        verification: getState().code_config.initAuth.verification,
                    },
                };

                const {origin, ...restPostalObj} = postalObj;

                let inputParams = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    zipCode: restPostalObj,
                };

                let queryParams = getState().route.queryParams;

                //add google recaptcha res code if showform=false and user is not present
                const {user, verification} = getState().code_config.initAuth;

                const isUserPresent = user && verification ? true : false;
                if (!getState().form.isFormSubmitSuccess && !isUserPresent) {
                    inputParams.gre_res = getState().code_config.reCaptchaResCode;
                }

                let data = {};
                if (getState().form.isFormSubmitSuccess) {
                    data.form_params = {};
                    if (getState().code_config.showFormCustomService) {
                        data.form_params.customService = getState().form.customService;
                    }
                    // data.form_params.pickup = getState().form.pickup;
                    data.form_params.pickup = cleanPickupDeliveryJson(
                        getState,
                        'pickup'
                    ).newDataJson;
                    // data.form_params.pickup = {
                    //   ...(data.form_params.pickup || {}),
                    //   ...getFormSelectedPort('pickup', getState),
                    // };
                    // data.form_params.delivery = getState().form.delivery;
                    data.form_params.delivery = cleanPickupDeliveryJson(
                        getState,
                        'delivery'
                    ).newDataJson;
                    // data.form_params.delivery = {
                    //   ...(data.form_params.delivery || {}),
                    //   ...getFormSelectedPort('delivery', getState),
                    // };
                    data.form_params.type = data.type;
                    data.form_params.factoryInfo = getState().form.factoryInfo;
                } else {
                    data.form_params = getSearchBookSaveParams({}, getState);
                    data.form_params.type = data.type;
                }

                if (queryParams.type === 'api-lcl') {
                    data.form_params.total_shipment = getState().code_config.lclShipment;
                } else if (queryParams.type === 'api-air') {
                    data.form_params.total_shipment = getState().code_config.airShipment;
                } else {
                    const tempContainer = getState().code_config.fclCounters;
                    let tempContainerArr = [];
                    if (tempContainer._20stCounter) {
                        tempContainerArr.push({
                            input: tempContainer._20stCounter,
                            type: "20'",
                            isOverweight: null,
                        });
                    }
                    if (tempContainer._40stCounter) {
                        tempContainerArr.push({
                            input: tempContainer._40stCounter,
                            type: "40'",
                            isOverweight: null,
                        });
                    }
                    if (tempContainer._40hqCounter) {
                        tempContainerArr.push({
                            input: tempContainer._40hqCounter,
                            type: "40'HC",
                            isOverweight: null,
                        });
                    }
                    if (!REMOVE_FCL_45_HC_CONTAINER && tempContainer._45hqCounter) {
                        tempContainerArr.push({
                            input: tempContainer._45hqCounter,
                            type: "45'HC",
                            isOverweight: null,
                        });
                    }
                    data.form_params.fclShipping = tempContainerArr;
                }

                data.object_type = 'postal_code_submit'; //for postal code

                const tempData = {
                    form_params: {...data.form_params, origin},
                    // selected_card_json: data.selected_card_json,
                    // selected_card_detail: data.selected_card_detail,
                    object_type: data.object_type,
                };
                inputParams = {
                    ...inputParams,
                    ...tempData,
                };

                console.log('zipcode inputParams', inputParams);
                // return;

                dispatch(updateErrorAndLoading(undefined, true));

                if (isDevENV()) {
                    await new Promise((resolve) => setTimeout(() => resolve(), 2000));
                    response.data = localZipCodePostJSON;
                    response.data = {
                        ...response.data,
                        name: `${
                            formZipCodeSubmit ? 'Form mode' : 'Search mode'
                        }-New Zip code Type - Vehicle`,
                    };
                } else {
                    let zipcodeTimeout = Number(SEARCH_ZIP_CODE_TIMEOUT_MIN);
                    zipcodeTimeout = isNaN(zipcodeTimeout) ? 0 : zipcodeTimeout;
                    zipcodeTimeout = zipcodeTimeout * 60 * 1000; //turn min to miliseconds
                    if (zipcodeTimeout) {
                        axios.defaults.timeout = zipcodeTimeout;
                    }

                    // zip code post url
                    let url;
                    if (isDevENV()) {
                        axios.defaults.timeout = 5 * 1000; //x sec
                        url = LOCAL_SERVER_URL + 'zip-code';
                    } else {
                        url = SEARCH_ZIP_CODE_POST_URL;
                    }
                    response = await axios.post(url, {params: inputParams}, axiosConfig);
                    console.log('zip code server res: ', response.data);
                    // if option has a rate property
                    if (
                        !formZipCodeSubmit &&
                        postalObj.option &&
                        postalObj.option.rate &&
                        (response.data === 0 || isEmpty(response.data) || !response.data)
                    ) {
                        // console.log('empty res?: ',  response.data);
                        // revert to rate obj
                        response.data = {
                            ...(postalObj.option || {}),
                            fetch_zip_code: false,
                        };
                        // console.log('new option: ', response.data);
                    }
                }

                // save postal code response
                postalObj = {
                    ...postalObj,
                    option: response.data && !isEmpty(response.data) ? response.data : {},
                    ...(formZipCodeSubmit && {formZipCodeSubmit}), //only for form zip code submit for new/existing factory
                };
                // console.log('zip code req postalObj: ', postalObj);
                //update fcl/lcl/air json in new function
                updateJsonAfterPostalSubmit(postalObj, getState, dispatch);

                dispatch(updateErrorAndLoading(undefined, undefined));
                if (callback) {
                    callback(true);
                }
            } catch (err) {
                console.log('zip code post error:', err);
                // for axios timeout error
                if (
                    !formZipCodeSubmit &&
                    postalObj.option &&
                    postalObj.option.rate &&
                    err.code === 'ECONNABORTED'
                ) {
                    console.log('axios timeout :(');
                    // revert to rate obj
                    response.data = {
                        ...(postalObj.option || {}),
                        fetch_zip_code: false,
                    };
                    // save postal code response
                    postalObj = {
                        ...postalObj,
                        ...(postalObj.option &&
                            postalObj.option.rate && {
                                option:
                                    response.data && !isEmpty(response.data) ? response.data : {},
                            }),
                    };
                    console.log('axios timeout new postalObj: ', postalObj);
                    //update fcl/lcl/air json in new function
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);

                    if (callback) {
                        callback(false);
                    }
                    dispatch(updateErrorAndLoading(undefined, undefined));
                    return;
                }
                if (callback) {
                    callback(false);
                }
                dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
            }

            // stop form zip code loading
            dispatch(
                setFormZipCodeSubmitLoading({
                    ...(postalObj.mode === 'pickup' && {isPickupLoading: false}),
                    ...(postalObj.mode === 'delivery' && {isDeliveryLoading: false}),
                })
            );
        };

/**
 * @function
 * @name updateJsonAfterPostalSubmit
 * @description  It updates fcl/lcl/air json after getting postal code response
 * @param {Object} postalObj - postal data
 * @param {Redux.State} getState - whole redux state
 * @param {Function} dispatch - dispatch function
 * @returns {Redux.Action} The generated action
 */
export const updateJsonAfterPostalSubmit = (postalObj, getState, dispatch) => {
    // save postal code response
    let tempSaveObj = {
        itemJsonId: postalObj.itemJsonId,
        mode: postalObj.mode,
        optionId: postalObj.optionId, //fetch zip code = true obj id
        zipCode: postalObj.zipCode,
        option: postalObj.option, //non zip code option object, modified by axios post request response
        ...(postalObj.formZipCodeSubmit && {
            formZipCodeSubmit: postalObj.formZipCodeSubmit,
        }), //only for form zip code submit for new/existing factory
    };

    let zipCodeArr = [...getState().route.zipCodeArr];

    zipCodeArr.push(tempSaveObj);
    dispatch({
        type: UPDATE_POSTAL_ZIP_CODE,
        payload: zipCodeArr,
    });

    // fclActive, lclActive, airActve are boolean
    const {fclActive, lclActive, airActve} = getActiveShipmentMode(getState);
    const seaFCLJSON = getState().route.seaFCLJSON;
    const seaLCLJSON = getState().route.seaLCLJSON;
    const airJSON = getState().route.airJSON;

    let tempSeaFCLJSON = {
        ...(seaFCLJSON || {}),
    };
    let tempSeaLCLJSON = {
        ...(seaLCLJSON || {}),
    };
    let tempAirJSON = {
        ...(airJSON || {}),
    };

    zipCodeArr = getState().route.zipCodeArr;

    // get zip code and update corresponding fcl/lcl/air json
    zipCodeArr.map((optionItemObj) => {
        if (fclActive) {
            // get temp updated fcl json
            tempSeaFCLJSON = getPostalUpdatedFclLclAirJson(
                tempSeaFCLJSON,
                getState,
                optionItemObj
            );
        } else if (lclActive) {
            // get temp updated lcl json
            tempSeaLCLJSON = getPostalUpdatedFclLclAirJson(
                tempSeaLCLJSON,
                getState,
                optionItemObj
            );
        } else if (airActve) {
            // get temp updated air json
            tempAirJSON = getPostalUpdatedFclLclAirJson(
                tempAirJSON,
                getState,
                optionItemObj
            );
        }
    });

    // console.log({ fclActive, lclActive, airActve });

    fclActive &&
    dispatch({
        type: SET_SEA_FCL_JSON,
        payload: tempSeaFCLJSON,
    }); //it will auto set empty obj to lcl/air json ;

    lclActive &&
    dispatch({
        type: SET_SEA_LCL_JSON,
        payload: tempSeaLCLJSON,
    });

    airActve &&
    dispatch({
        type: SET_AIR_JSON,
        payload: tempAirJSON,
    });

    // remove old zipcode arr after it has been updated in rates json
    //TODO- it is newly added here, it was not here before, check it couple of times
    dispatch({
        type: UPDATE_POSTAL_ZIP_CODE,
        payload: [], //set it empty now
    });

    // re-render pickup delivery ers line upon submitting postal codes
    dispatch({
        type: UPDATE_PICKUP_DELIVERY_ERS_LINE,
    });
};

/**
 * @function
 * @name postSailingSchedule
 * @description  It's for sailing schedule post request on search page.
 * @param {Object} itemJson - single rate card json on which sailing schedule is clicked on
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const postSailingSchedule =
    (itemJson, callback = undefined) =>
        async (dispatch, getState) => {
            try {
                // const username = getState().config.username;

                // cancel previous axios post request if present
                if (window.sailing_schedule_axios_source) {
                    window.sailing_schedule_axios_source.cancel();
                }
                axios.defaults.timeout = 200000; //200 seconds
                const CancelToken = axios.CancelToken;
                window.sailing_schedule_axios_source = CancelToken.source();

                let axiosConfig = {
                    // headers: {
                    //   'Content-Type': 'application/json',
                    //   Authorization: `Bearer ${AUTH_TOKEN}`,
                    //   user: getState().code_config.initAuth.user,
                    //   verification: getState().code_config.initAuth.verification,
                    // },
                    cancelToken: window.sailing_schedule_axios_source.token,
                };

                const params = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    itemJson,
                    object_type: 'sailing_schedule',
                    show_variable_rate: !!itemJson.show_variable_rate,
                    //port to/from (get it from url), date,
                    ...getSailingPOSTparam(
                        getState().form.isFormSubmitSuccess,
                        getState().route.queryParams
                    ),
                    //  carrier, discharge port
                    port_of_discharge: itemJson.port_of_discharge || '',
                    carrier: itemJson.sealine || itemJson.company_name || '',
                    // transhipment_ports
                    ...(itemJson.transhipment_ports && {
                        transhipment_ports: itemJson.transhipment_ports,
                    }),
                };

                // console.log('sailing schedule params : ', params);

                // dispatch(updateErrorAndLoading(undefined, true));

                let response = {};
                if (isDevENV()) {
                    await new Promise((resolve) => setTimeout(() => resolve(), 500));
                    response.data = localSailingScheduleJSON;
                } else {
                    let sailingScheduleTimeout = Number(
                        SEARCH_SAILING_SCHEDULE_TIMEOUT_MIN
                    );
                    sailingScheduleTimeout = isNaN(sailingScheduleTimeout)
                        ? 0
                        : sailingScheduleTimeout;
                    sailingScheduleTimeout = sailingScheduleTimeout * 60 * 1000; //turn min to miliseconds
                    if (sailingScheduleTimeout) {
                        axios.defaults.timeout = sailingScheduleTimeout;
                    }

                    let url = SAILING_SCHEDULE_POST_URL;
                    // url = 'http://localhost:5000/sailing-schedule'; // remove this, it is for test
                    response = await axios.post(url, {params}, axiosConfig);
                }

                // console.log('response : ', response.data);

                //reset sailing modal marginTop position
                dispatch(updateParentScrollbarPosition(0));

                if (callback) {
                    callback({success: true, resJson: response.data || {}});
                }
                dispatch(updateErrorAndLoading(undefined, undefined));
            } catch (err) {
                console.log('error: ', err);
                dispatch(updateErrorAndLoading(err.message, undefined));
                if (callback) {
                    callback({success: false});
                }
                if (axios.isCancel(err)) {
                    console.log('previous token is canceled!');
                    // keep spinning if the previous token is cancelled
                    // because a current request is going on
                    // dispatch(updateErrorAndLoading(undefined, true));
                }
            }
        };

/**
 * @function
 * @name postUserEmailBlurCards
 * @description  It's posts email address of user in blur cards overlay to remote endpoint
 * @param {string} emailStr - email
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const postUserEmailBlurCards =
    (emailStr, callback = undefined) =>
        async (dispatch, getState) => {
            try {
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                        user: getState().code_config.initAuth.user,
                        verification: getState().code_config.initAuth.verification,
                    },
                };

                // add form data
                const params = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    userEmailBlurCards: emailStr,
                    form_data: getState().route.queryParams,
                };

                dispatch(updateErrorAndLoading(undefined, true));

                // console.log({ params });

                let response = {};
                if (isDevENV()) {
                    await new Promise((resolve) => setTimeout(() => resolve(), 2000));
                    response.data = {success: true};
                } else {
                    response = await axios.post(
                        USER_EMAIL_BLUR_CARDS_POST_URL,
                        {params},
                        axiosConfig
                    );
                }

                //update in redux store
                dispatch(saveSearchBlurCardsEmail(emailStr));

                //don't show search blur cards
                dispatch(showSearchBlurCards(false));

                if (callback) {
                    callback({success: true});
                }
                dispatch(updateErrorAndLoading(undefined, undefined));
            } catch (err) {
                console.log('error: ', err);
                dispatch(updateErrorAndLoading(err.message, undefined));
                //update in redux store
                // dispatch(saveSearchBlurCardsEmail(null));
                if (callback) {
                    callback({success: false});
                }
            }
        };
